import { createIcon } from '../createIcon';

export const CircleArrowRightIconConfig = {
  name: 'CircleArrowRightIcon',
  height: 512,
  width: 512,
  svgPath: 'M0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM281 385c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l71-71L136 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l182.1 0-71-71c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L393 239c9.4 9.4 9.4 24.6 0 33.9L281 385z',
  yOffset: 0,
  xOffset: 0
};

export const CircleArrowRightIcon = createIcon(CircleArrowRightIconConfig);

export default CircleArrowRightIcon;